import React from 'react';
import BN from 'bignumber.js';
import { useSelector } from 'react-redux';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-confirm.module.scss';
import Header from '../../../../../../../components/Stake/header';
import theme from '../../../../../../../theme';
import { OM, SHORT_CLAIM_PENALTY } from '../../../../../../../constants/blockchain-constants';
import { formatToken } from '../../../../../../../helpers/token-helper';
import loading from '../../../../../../../assets/images/loading.png';
import styled from 'styled-components';
import PolygonLogo from '../../../../../../../external/components/Icon/polygon';

const PolyLogo = styled(PolygonLogo)`
  width: 34px;
  height: 34px;
  margin-right: 0.25rem;
  margin-left: 0.25rem;
`;

const ClaimConfirm = ({ long }) => {
  const unclaimedAmount = useSelector((state) => state.delegator.matic.unclaimedAmount);

  const amountToClaim = long
    ? unclaimedAmount
    : new BN((1 - SHORT_CLAIM_PENALTY) * unclaimedAmount).toString(10);

  return (
    <>
      <Header componentIcon={<PolyLogo />} title='OM-Claim' />
      <div className={stylesParent.cardContent}>
        <div>
          <div className={stylesParent.cardTextRow}>
            <div className={stylesParent.cardTextRowLabel}>You Are Claiming:</div>
            <div className={stylesParent.cardTextRowValue}>
              <b>
                {formatToken(amountToClaim)} {OM}
              </b>
            </div>
          </div>
        </div>
        <div className={styles.descriptionContainer}>
          <div>
            <img src={loading} className='rotate' alt='' />
          </div>
          <div className={styles.confirm}>
            <span style={{ color: theme.palette.mantra.pink, fontWeight: 800 }}>Confirming...</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClaimConfirm;
